module.exports = __webpack_public_path__ + "svg/unauth-burger.svg?cb38a5d3bef703f41d48e8fc4da4f90c";